import { useContext } from 'react';
import { NarrativeContext, NarrativeContextValue } from '../contexts/NarrativeContext';

export type UseNarrativeReturn = NarrativeContextValue;

export function useNarrative(): UseNarrativeReturn {
  const context = useContext(NarrativeContext);
  
  if (!context) {
    throw new Error('useNarrative must be used within a NarrativeProvider');
  }
  
  return context;
}